var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOdigo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 40,
    viewBox: "0 0 93 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_233_1075)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8086 28.2854H45.3991V9.45728H40.8086V28.2854Z",
    fill: "#2B3146"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0066 23.6443C55.335 23.6443 53.1527 21.7047 53.1527 18.4335C53.1527 15.1623 55.335 13.1458 58.0066 13.1458C60.6407 13.1458 62.8237 15.2004 62.8237 18.4335C62.8237 21.6666 60.6407 23.6443 58.0066 23.6443ZM67.3768 18.4335C67.3768 16.379 66.8494 14.5155 65.4197 12.8799L67.4897 10.2174L64.103 7.63037L62.2589 9.98889C60.9796 9.11429 59.4744 8.92388 58.0066 8.92388C52.8138 8.92388 48.5996 12.5753 48.5996 18.4335C48.5996 24.2911 52.2116 27.8669 58.0066 27.8669C60.3025 27.8669 62.7107 29.0455 62.7107 31.6325C62.7107 34.2189 60.6407 35.6641 58.0066 35.6641C55.3731 35.6641 53.1527 34.0666 53.1527 31.6325H48.5996C48.5996 36.6917 52.626 40.001 58.0066 40.001C63.3878 40.001 67.3012 36.8059 67.3012 31.6325C67.3012 29.2359 66.5486 26.9917 63.4633 25.4322C66.5112 24.0251 67.3768 20.7539 67.3768 18.4335Z",
    fill: "#2B3146"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.7062 18.9252C89.7062 24.3264 86.0561 28.7007 80.0352 28.7007C74.0144 28.7007 70.4023 24.3264 70.4023 18.9252C70.4023 13.5614 74.0899 9.14966 79.9978 9.14966L80.0352 13.3716C76.724 13.3716 74.9929 16.1103 74.9929 18.9252C74.9929 21.7781 76.6866 24.4407 80.0352 24.4407C83.3845 24.4407 85.0776 21.7775 85.0776 18.9252H89.7062Z",
    fill: "#2B3146"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.9648 6.5979C85.8733 6.59984 92.1498 6.62114 92.1498 6.62114C92.1498 6.62114 92.1543 12.8137 92.1543 15.819L88.0375 15.8164C88.0401 14.0459 88.0866 10.8367 88.0866 10.8367C88.0866 10.8367 84.5856 10.8321 82.9874 10.8341L82.9648 6.5979Z",
    fill: "#E73C68"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8151 4.24489C45.8151 7.85883 40.3965 7.85883 40.3965 4.24489C40.3965 0.631587 45.8151 0.631587 45.8151 4.24489Z",
    fill: "#2B3146"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.50477 18.2663C5.50477 21.247 7.27463 24.029 10.775 24.029C14.2721 24.029 16.042 21.247 16.042 18.2663C16.042 15.3256 13.9958 12.4636 10.775 12.4636C7.31271 12.4636 5.50413 15.3256 5.50413 18.2663M20.8765 18.2663C20.8765 23.9096 17.0624 28.4807 10.775 28.4807C4.48171 28.4801 0.708984 23.9096 0.708984 18.2663C0.708984 12.6637 4.56175 8.05249 10.733 8.05249C16.9056 8.05249 20.8765 12.6637 20.8765 18.2663Z",
    fill: "#2B3146"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8478 18.2669C37.8478 17.9016 37.8304 17.5408 37.7968 17.1845V0.000976562H32.9268V9.3718C31.4539 8.53464 29.6943 8.05312 27.7044 8.05312C25.0063 8.05312 22.7517 8.93418 21.0684 10.3949C22.2838 11.4341 23.2113 12.7656 23.7987 14.2812C24.683 13.1878 26.0061 12.4642 27.7463 12.4642C30.5844 12.4642 32.5085 14.6846 32.9268 17.2245V19.3907C32.5344 21.9112 30.7987 24.0296 27.7463 24.0296C26.0068 24.0296 24.6952 23.3422 23.8154 22.2849C23.2365 23.8173 22.3147 25.1553 21.0916 26.1926C22.7698 27.6223 25.0212 28.4807 27.7463 28.4807C29.735 28.4807 31.4758 28.0224 32.9268 27.2188V28.2032L37.7968 28.2096V19.3732C37.8304 19.0099 37.8485 18.6413 37.8485 18.2669",
    fill: "#2B3146"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_233_1075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91.4455,
    height: 40,
    fill: "white",
    transform: "translate(0.708984 0.000976562)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdigo);
export default __webpack_public_path__ + "static/media/Odigo.16ab86d3dbefb3ddae26437441ad777f.svg";
export { ForwardRef as ReactComponent };